export function formatTopicScore(
  topic: Partial<{ score: number; maxScore: number }>,
): string {
  return displayDecimal(topic.score) + ' / ' + displayDecimal(topic.maxScore);
}

export const formatScore = formatTopicScore;

export function displayTonsToKg(value: number): string {
  if (typeof value === 'number') value = value / 1000;
  return displayDecimal(value);
}

export function displayDecimal(value: number | undefined): string {
  if (typeof value !== 'number') {
    return '-';
  }
  return value.toFixed(2).replace('.', ',').replace(',00', '');
}
